import { useEffect, useState } from 'react';
import styles from './ProjectGallery.module.css'
import { sanityClient } from '../../../../../../lib/sanity.client';
import { LogoProjectGalleryInterface } from '../../../../../../lib/types/logoProjectGallery';
import { ProjectInterface } from '../../../../../../lib/types/project';
import Logo from './Logo/Logo';
import Mockup from './Mockups/Mockup';
import { MockupProjectGalleryInterface } from '../../../../../../lib/types/mockupProjectGallery';
import { PhotosProjectGalleryInterface } from '../../../../../../lib/types/photosProjectGallery';
import Photos from './Photos/Photos';
import { VideosProjectGalleryInterface } from '../../../../../../lib/types/videosProjectGallery';
import Videos from './Videos/Videos';
import VideoSideToSide from './VideoSideToSide/VideoSideToSide';
import { VideosSideToSideProjectGalleryInterface } from '../../../../../../lib/types/videosSideToSideProjectGallery';

export type ProjectGalleryProps = {
    id: string;
}

const ProjectGallery = (props: ProjectGalleryProps) => {

    const [logoPG, setLogoPG] = useState<LogoProjectGalleryInterface | null>(null);
    const [mockupPG, setMockupPG] = useState<MockupProjectGalleryInterface[]>([]);
    const [photosPG, setPhotosPG] = useState<PhotosProjectGalleryInterface | null>(null);
    const [videosPG, setVideosPG] = useState<VideosProjectGalleryInterface | null>(null);
    const [videosSTSPG, setVideosSTSPG] = useState<VideosSideToSideProjectGalleryInterface | null>(null);

    useEffect(() => {
        const queryLogo = `*[
          _type == "logoProjectGallery" &&
          project._ref == $id
        ]{
          ...
        }`;

        const queryMockup = `*[
            _type == "mockupProjectGallery" &&
            project._ref == $id
          ] | order(mockupOrder asc) {
            ...
        }`;

        const queryPhotos = `*[
            _type == "photosProjectGallery" &&
            project._ref == $id
          ]{
            ...
          }`;

        const queryVideos = `*[
            _type == "videosProjectGallery" &&
            project._ref == $id
          ]{
            ...
          }`;

        const queryVideos2 = `*[
            _type == "videosSideToSideProjectGallery" &&
            project._ref == $id
          ]{
            ...
          }`;

        (sanityClient as any)
        .fetch(queryLogo, { id: props.id })
        .then((data: LogoProjectGalleryInterface[]) => {
            setLogoPG(data[0]);
        })
        .catch(console.error);

        (sanityClient as any)
        .fetch(queryMockup, { id: props.id })
        .then((data: MockupProjectGalleryInterface[]) => {
            setMockupPG(data);
        })
        .catch(console.error);

        (sanityClient as any)
        .fetch(queryPhotos, { id: props.id })
        .then((data: PhotosProjectGalleryInterface[]) => {
            setPhotosPG(data[0]);
        })
        .catch(console.error);

        (sanityClient as any)
        .fetch(queryVideos, { id: props.id })
        .then((data: VideosProjectGalleryInterface[]) => {
            setVideosPG(data[0]);
        })
        .catch(console.error);

        (sanityClient as any)
        .fetch(queryVideos2, { id: props.id })
        .then((data: VideosSideToSideProjectGalleryInterface[]) => {
            setVideosSTSPG(data[0]);
        })
        .catch(console.error);
      }, [props.id]);

    return (
        <div className={styles.container}>
            {/* LOGO */}
            <div className={styles.item}>
                <Logo logoPG={logoPG} />
            </div>

            {/* MOCKUPS */}
            <div className={styles.item}>
                <Mockup mockupPG={mockupPG} />
            </div>


            {/* PHOTOS */}
            <div className={styles.item}>
                <Photos photosPG={photosPG} />
            </div>


            {/* VIDEOS */}
            <div className={styles.item}>
                <Videos videosPG={videosPG} />
            </div>
            {/* VIDEOS side to side */}
            <div className={styles.item}>
                <VideoSideToSide videosSTSPG={videosSTSPG} />
            </div>
        </div>
    )
}

export default ProjectGallery
